import React, { useEffect } from 'react';
import bem from '../../../utils/bem.js';
import { JazzRoom } from '@salutejs/jazz-sdk-web';
import { useVideoSources } from '../utils/hooks/useActiveVideoSource'
import { useVideoElement } from '../utils/hooks/useVideoElement';
import { useRoomContext } from '../contexts/RoomContext';
import { booleanAttribute } from '../utils'
import { MainVideoPlaceholder } from './VideoPlaceholder';
import { useFullscreen } from '../utils/hooks/useFullscreen';
import './index.sass';

const { block, el } = bem('conference-video');
export const MainVideo = ({ participantId, isFullscreen }) => {

    const { room } = useRoomContext();
    const { primary } = useVideoSources(participantId);

    const primaryVideoElement = useVideoElement<HTMLDivElement>({
        participantId,
        room: room as JazzRoom,
        source: primary,
        height: 800,
        quality: 'high',
    });

    const secondaryVideoElement = useVideoElement<HTMLDivElement>({
        participantId,
        room: room as JazzRoom,
        source: primary,
        height: 800,
        quality: 'low',
    });

    return (
        <div className={ el('container', 'main') }>
            <div className={ block('main') }
                 style={ {
                     position: 'absolute',
                     width: '100%',
                     height: '100%',
                     left: 0,
                     right: 0,
                     filter: 'blur(20px)'
                 } }
                 ref={ secondaryVideoElement.videoRootRef }
                 data-paused={ booleanAttribute(secondaryVideoElement.isVideoPaused) }
                 data-fit="cover"
            />
            <div className={ block('main') }
                 ref={ primaryVideoElement.videoRootRef }
                 data-paused={ booleanAttribute(primaryVideoElement.isVideoPaused) }
                 data-fit={`${isFullscreen ? 'cover' : 'contain'}`}
            />
            { primaryVideoElement.isVideoMuted && <MainVideoPlaceholder /> }
        </div>
    )
}
